import React from "react";
import DisplayFile from "./DisplayFile";
import MoveableFile from "./MoveableFile";

const PostUploadsBlock = ({isDraggable = false, fileFormats, uploads, limit = null, moveFile = null, removeFile = null, selectFile= null, unselectFile = null, select = null, unselect = null}) => {  

  const renderFiles = (file, index) => {
    return isDraggable ? (
       <MoveableFile
        file={file}
        index={index}
        key={`${file.id}-file`}
        moveFile={moveFile}
        removeFile={removeFile}
        fileFormats={fileFormats}
        limit={limit}
      />
      ) : (
      <DisplayFile
        file={file}
        index={index}
        key={`${file.id}-file`}
        limit={limit}
        selectFile={(data) => selectFile(data)}
        unselectFile={(data) => unselectFile(data)}
        select={select}
        unselect={unselect}
      />
      )
  };

  return (
    <section className="row popup-gallery mt-2">
      {
        uploads.map((file, index) => {
          if (limit && index >= limit) {
            return null
          } else {
            return file ? renderFiles(file, index) : null
          }
        })
      }
    </section>
  )
}

export default PostUploadsBlock;